// Uang selalu Rupiah bulat.

/** Nilai baris = qty × (harga − diskon per satuan), dibulatkan ke rupiah. */
/**
 * Jumlah baris = qty × harga − (satuan UTUH × potongan per satuan) — sesuai nota owner: 2 bal → "2 Balx@Rp2.500",
 * 0,5 bal → "0 Balx@Rp2.500" (pecahan tidak mendapat potongan).
 */
export const discUnits = (qty: number): number => Math.floor((Number(qty) || 0) + 1e-6);
export const lineDisc = (qty: number, disc = 0): number => discUnits(qty) * (disc || 0);
export const lineAmount = (qty: number, price: number, disc = 0): number =>
  Math.round((Number(qty) || 0) * price - lineDisc(qty, disc));

/** "Rp1.250.000" — format sama dengan v1. */
export const rupiah = (n: number | null | undefined): string => `Rp${Number(n || 0).toLocaleString('id-ID')}`;
